import { render, staticRenderFns } from "./RLVEvidenceActionContent.vue?vue&type=template&id=7936d842&scoped=true"
import script from "./RLVEvidenceActionContent.vue?vue&type=script&lang=js"
export * from "./RLVEvidenceActionContent.vue?vue&type=script&lang=js"
import style0 from "./RLVEvidenceActionContent.vue?vue&type=style&index=0&id=7936d842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936d842",
  null
  
)

export default component.exports